import Backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import SecurityKeyCollection from "src/shared/security-keys/SecurityKeyCollection";
import SecurityKeyTypes from "src/shared/security-keys/SecurityKeyTypes";
import RewardSupplierFilterCollection from "src/shared/webhooks/RewardSupplierFilterCollection";
import RewardSupplierTagsFilterCollection from "src/shared/webhooks/RewardSupplierTagsFilterCollection";
import StateFilterCollection from "src/shared/webhooks/StateFilterCollection";
import omissible from "src/shared/api/omissible";

const PICK_ATTRIBUTES = [
    "name",
    "description",
    "client_key_id",
    "url",
    "enabled",
    "tags",
    "response_handler",
    "request",
    "type",
];
const UPDATE_ATTRIBUTES = _.without(PICK_ATTRIBUTES, "type");
const OPTIONAL_KEYS = [
    "client_key_id",
    "description",
    "response_handler",
    "default_method",
    "type",
];

const WebhookModel = Backbone.Model.extend({
    urlRoot: "/api/v6/webhooks",

    defaults: {
        name: null,
        client_key_id: null,
        url: null,
        description: null,
        default_method: "POST",
        request: null,
        response_handler: null,
        enabled: false,
        tags: [],
    },

    initialize() {
        this.stateFilterCollection = StateFilterCollection.create(this);
        this.rewardSupplierFilterCollection =
            RewardSupplierFilterCollection.create(this);
        this.rewardSupplierTagsFilterCollection =
            RewardSupplierTagsFilterCollection.create(this);
    },

    sync(method, model, options) {
        let requestAttributes = _.pick(this.attributes, PICK_ATTRIBUTES);
        if (method === "update") {
            requestAttributes = _.pick(this.attributes, UPDATE_ATTRIBUTES);
        }
        if (_.isEmpty(requestAttributes.request)) {
            requestAttributes.request = null;
        }
        if (_.isEmpty(requestAttributes.response_handler)) {
            requestAttributes.response_handler = null;
        }
        omissible.parseAttributes(
            requestAttributes,
            _.difference(PICK_ATTRIBUTES, OPTIONAL_KEYS),
            OPTIONAL_KEYS
        );
        options.attrs = requestAttributes;
        return Backbone.sync.call(this, method, model, options);
    },

    getClientKeyModel() {
        const deferred = $.Deferred();
        const keyCollection = SecurityKeyCollection.create(
            SecurityKeyTypes.WEBHOOK
        );
        keyCollection
            .fetch()
            .done(() => {
                const keyModel = keyCollection.get(this.get("client_key_id"));
                deferred.resolve(keyModel);
            })
            .fail(deferred.reject);

        return deferred;
    },
});

WebhookModel.create = function (webhookdId) {
    return new WebhookModel({
        id: webhookdId,
    });
};

export default WebhookModel;
